import { render, staticRenderFns } from "./HistoricalTransactionHeader.vue?vue&type=template&id=7f998ad8&"
import script from "./HistoricalTransactionHeader.vue?vue&type=script&lang=js&"
export * from "./HistoricalTransactionHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports